import * as XLSX from "xlsx";

const SHEET_NAME = "Products";
const FILENAME = "product_upload_format.xlsx";

const TEMPLATE_HEADERS = [
 "SKU Code",                    
 "SKU Name",                    
 "Description",                 
 "Company",    
 "Base Price",
 "Cases Per Pallet",                        
 "Unit of Measure (UOM)",       
 "Unit of Measure (Inner)",     
 "Weight (kg)",                 
 "Supplier Name",               
 "SKU Category",                
 "Manufacturing Date",          
 "Expiry Date",                 
 "Location",                    
 "Length (cm)",                 
 "Breadth (cm)",                
 "Height (cm)",                 
 "Batch Controlled",            
];

// Helper row (parser should skip this row)
const INSTRUCTIONS_ROW = [
 "Optional. Leave blank to auto-generate",
 "Required. Example: iPhone 15 Pro 256GB",
 "Required. Short description/name",
 "Optional. Company name(s), comma separated",
 "Required. number >= 0 (product base price)", 
 "Optional. integer >= 1 (e.g. 40)",
 "Required. e.g. PCS / BOX / UNIT / L / KG / PACK / CASE",
 "Required. Inner UOM",
 "Required. number >= 0",
 "Optional. Supplier name",
 "Optional. CORE or NON_CORE",
 "Optional. Date (YYYY-MM-DD)",
 "Optional. Date (YYYY-MM-DD)",
 "Optional. e.g. Warehouse A",
 "Required. number >= 0",
 "Required. number >= 0",
 "Required. number >= 0",
 "Optional. YES or NO",
];

const SAMPLE_ROW_1 = [
 "SKU-001",
 "SKU Name Example",
 "Short description example",
 "Company A, Company B",  
 999.99,
 40, 
 "PCS",
 "PCS",
 1.2,
 "ABC Supplier",
 "NON_CORE",
 "2026-02-01",
 "2026-08-01",
 "Warehouse A",
 10,
 5,
 3,
 "YES",
];
export function downloadProductUploadTemplate() {
  const wsData = [TEMPLATE_HEADERS, INSTRUCTIONS_ROW, SAMPLE_ROW_1];

  const ws = XLSX.utils.aoa_to_sheet(wsData);

  // ✅ Column widths for readability (14 columns)
  ws["!cols"] = [
   { wch: 18 },
   { wch: 28 },
   { wch: 28 },
   { wch: 26 },
   { wch: 16 }, 
   { wch: 18 },
   { wch: 20 },
   { wch: 22 },
   { wch: 14 },
   { wch: 22 },
   { wch: 16 },
   { wch: 18 },
   { wch: 18 },
   { wch: 18 },
   { wch: 14 },
   { wch: 14 },
   { wch: 14 },
   { wch: 18 },
 ];

  // ✅ Data validation dropdowns
  const startRow = 3;
  const endRow = 5000;

  ws["!dataValidation"] = [
   // UOM → Column F
   {
     type: "list",
     allowBlank: 0,
     sqref: `F${startRow}:F${endRow}`,
     formulas: ['"PCS,KG,L,BOX,PACK,CASE,UNIT"'],
   },
 
   // Inner UOM → Column G
   {
     type: "list",
     allowBlank: 0,
     sqref: `G${startRow}:G${endRow}`,
     formulas: ['"PCS,KG,L,BOX,PACK,CASE,UNIT"'],
   },
 
   // SKU Category → Column K
   {
     type: "list",
     allowBlank: 1,
     sqref: `K${startRow}:K${endRow}`,
     formulas: ['"CORE,NON_CORE"'],
   },
 
   // Batch Controlled → Column R
   {
     type: "list",
     allowBlank: 1,
     sqref: `R${startRow}:R${endRow}`,
     formulas: ['"YES,NO"'],
   },
 ];
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, SHEET_NAME);

  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([wbout], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = FILENAME;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
